import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { RoomsModel } from 'src/app/models/RoomsModel';
import { RoomsService } from 'src/app/services/RoomsService';
import { LocalStorageService } from 'ngx-webstorage';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';   ///=== for searching pop up



@Component({
  selector: 'app-roomssearch',
  templateUrl: './roomssearch.component.html',
  styleUrls: ['./roomssearch.component.css']
})
export class RoomssearchComponent implements OnInit {
  roomCode = '';
  roomName = '';
  roomType = '';
  roomNotes = '';
  compCode = '1';
  userID = '';
  modifiedDate = '2021-01-01';

  roomsList: RoomsModel[] = [];
  @Output() submitClicked = new EventEmitter<any>();


  constructor(public roomsService: RoomsService,
              public rooms: RoomsModel,
              public storage: LocalStorageService,
              public dialogRef: MatDialogRef<RoomssearchComponent>,
              @Inject(MAT_DIALOG_DATA)
              public roomsSelectedData: RoomsModel) { }

  ngOnInit(): void {this.retriveRoomsLookupTop();
  }

  retriveRoomsLookup() {
    this.roomsList = [];
    this.roomsService.getRoomsLookup(this.roomCode, this.roomName, this.compCode).subscribe((data: RoomsModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.roomsList[i] = data[i];
      }
      console.log(data);
    })
  }

  retriveRoomsLookupTop() {
    this.roomsList = [];
    this.roomsService.getRoomsLookupTop(this.compCode).subscribe((data: RoomsModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.roomsList[i] = data[i];
      }
      console.log(data);
    })

  }

  SelectRoom(room: RoomsModel){
    this.roomsSelectedData.roomCode = room.roomCode
    this.roomsSelectedData.roomName = room.roomName
    this.roomsSelectedData.roomType= room.roomType
    this.roomsSelectedData.roomNotes= room.roomNotes

    this.roomsSelectedData.userID = room.userID
    this.roomsSelectedData.modifiedDate = room.modifiedDate
    this.roomsSelectedData.compCode = room.compCode
    this.submitClicked.emit(this.roomsSelectedData);
    this.dialogRef.close();
  }
}
